$(document).on('click', '[data-clipboard]', function (e) {
    e.stopPropagation();
    const target = $(this);
    const copyval = target.attr('data-clipboard');

    navigator.clipboard.writeText(copyval);
    target.popover('show');
    setTimeout(function () {
        target.popover('hide');
    }, 2000);
});